import React from 'react';
import { ProductReviewForm } from './ProductReviewForm';
import { RCButton } from '@reverbdotcom/cadence/components';
import { Modal } from '@reverbdotcom/commons';
import { ProductReviewCSPFields } from '@reverbdotcom/commons/src/gql/graphql';
import I18n from 'i18n-js';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { ProductReviewInteraction } from '@reverbdotcom/commons/src/elog/mparticle_types';

interface Props {
  csp: ProductReviewCSPFields.Fragment;
  trackingDisplayStyle: 'product' | 'csp';
}

export function ProductReviewFormButton(props: Props) {
  const { csp, trackingDisplayStyle } = props;
  const buttonState = useButtonState(!!csp.myReview, trackingDisplayStyle, csp.id);

  return (
    <>
      <RCButton
        variant="filled"
        onClick={buttonState.onClick}
      >
        {buttonState.text}
      </RCButton>

      <Modal
        data-product-review-form-modal
        isOpen={buttonState.isModalOpen}
        onRequestClose={buttonState.closeModal}
        headerTitle={buttonState.text}
      >
        <div className="ptb-6 plr-4 bdb-1 bd-color-primary">
          <ProductReviewForm
            cspId={csp.id}
            myReview={csp?.myReview}
            trackingDisplayStyle={trackingDisplayStyle}
          />
        </div>
      </Modal>
    </>
  );
}

function useButtonState(hasReview: boolean, trackingDisplayStyle: 'product' | 'csp', cspId: string) {
  const [isModalOpen, showModal] = React.useState(false);

  function buttonText() {
    if (hasReview) {
      return I18n.t('discovery.productReviews.form.editReview');
    }

    return I18n.t('discovery.productReviews.form.createReview');
  }

  function closeModal() {
    showModal(false);
  }

  function onClick() {
    showModal(true);

    trackEvent({
      eventName: MParticleEventName.ProductReviewAction,
      productReviewInteraction: ProductReviewInteraction.StartReview,
      displayStyle: trackingDisplayStyle,
      cspId: cspId,
    });
  }

  return {
    text: buttonText(),
    isModalOpen,
    closeModal,
    onClick,
  };
}
